import { useParams } from '@xing-com/crate-core-router';

import { TopicPageEntry } from './topic-page-entry';

export const TopicPageVersionResolver: React.FC = () => {
  const { topicKey } = useParams();

  return <TopicPageEntry topicKey={topicKey} />;
};
